import React from 'react'
import Layout, { Container } from '../components/layout'
import ComingSoon from '../components/comingSoon'

function Loyalty() {
    return (
        <Layout>
            <Container>
                <ComingSoon />
            </Container>
        </Layout>
    )
}

export default Loyalty